import { BagelVue, RouterWrapper } from '@bagelink/vue'
import type { CreateBloxAppOptions } from '@bagelink/blox'

export const bloxSite = {
	modules: import.meta.glob<Extract<CreateBloxAppOptions['modules'], Record<string, unknown>>[string]>('./components/blocks/*.vue', { eager: true }),
	websiteName: 'thetorah',
	store: 'the_torah',
	locale: 'en',
	supportedLocales: ['en'],
	plugins: [[BagelVue, {}]] satisfies CreateBloxAppOptions['plugins'],
	globalComponents: { RouterWrapper },
}
